var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medicine-list" },
    [
      _c(
        "pull-refresh",
        {
          on: { refresh: _vm.refreshList },
          model: {
            value: _vm.pullLoading,
            callback: function ($$v) {
              _vm.pullLoading = $$v
            },
            expression: "pullLoading",
          },
        },
        [
          _vm.listInfo.length
            ? _c(
                "list",
                {
                  attrs: {
                    finished: !_vm.hasNext,
                    "finished-text": "没有更多了",
                    "immediate-check": false,
                  },
                  on: { load: _vm.loadList },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                [
                  _vm.listInfo.length == 0 && !_vm.loading
                    ? _c("div", {
                        staticStyle: {
                          "text-align": "center",
                          padding: "10vh 0",
                        },
                      })
                    : _vm._e(),
                  _c("page-layout", [
                    !_vm.pullLoading
                      ? _c("div", { staticClass: "medicine-list__header" }, [
                          _vm.showTip
                            ? _c(
                                "div",
                                { staticClass: "medicine-list__title" },
                                [_vm._v("选择用药人")]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "medicine-list__subtitle" },
                            [
                              _vm._v(
                                " 为保证用药安全，请添加实际使用药品的用药人，平台将严格保护用药人隐私。 "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "medicine-list__content" },
                      _vm._l(_vm.listInfo, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "medicine-list__item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "medicine-list__item-info",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSelect(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "medicine-list__item-left" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "medicine-list__item-check",
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "iconfont icon-check",
                                          class: { active: item.selected },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "medicine-list__item-detail",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "medicine-list__item-name",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            ),
                                            item.relation === "self"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "medicine-list__item-tag",
                                                  },
                                                  [_vm._v("本人")]
                                                )
                                              : _vm._e(),
                                            item.isVerified
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "medicine-list__item-tag",
                                                  },
                                                  [_vm._v("已认证")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "medicine-list__item-desc",
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.hideMiddleChars(
                                                    item.phone
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.hideMiddleChars(
                                                    item.idCard
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "medicine-list__item-right" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "edit-icon" },
                                      [
                                        _c("van-icon", {
                                          attrs: { name: "edit" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleEdit(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "delete-icon" },
                                      [
                                        _c("van-icon", {
                                          attrs: { name: "delete" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleDelete(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          !_vm.listInfo.length
            ? _c("empty", { attrs: { description: "暂无用药人，请添加" } })
            : _vm._e(),
        ],
        1
      ),
      _c("fixed-button", {
        attrs: { text: "+ 添加用药人" },
        on: { emitEvent: _vm.handleAdd },
      }),
      _c("van-dialog", {
        attrs: {
          title: "提示",
          message: "确定要删除该用药人吗？",
          "show-cancel-button": "",
        },
        on: { confirm: _vm.confirmDelete },
        model: {
          value: _vm.showDeleteDialog,
          callback: function ($$v) {
            _vm.showDeleteDialog = $$v
          },
          expression: "showDeleteDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }